import PropTypes from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss';

import { useIntl } from 'react-intl';

import styles from './LoginPageContainer.styles';

function LoginPageContainer({ classes, children, title }) {
  const intl = useIntl();

  return (
    <div className={classes.container}>
      <div className={classes.logoContainer}>
        <a
          href="/"
          title={intl.formatMessage({
            id: 'LoginPageContainer.logoLinkTitle',
            defaultMessage: 'Evisort login page',
            description: 'Title for logo link on login page',
          })}
        >
          <img
            src="/evisort.png"
            alt="Evisort"
            title="Evisort"
            className={classes.logoImg}
          />
        </a>
      </div>
      <div className={classes.contentContainer}>
        <div className={classes.title} role="heading" aria-level="1">
          {title}
        </div>
        {children}
      </div>
    </div>
  );
}

LoginPageContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(LoginPageContainer);
